export type VideoSource = {
    kind: 'embed' | 'file'
    src: string
}

const youtubeEmbed = (id: string): VideoSource => ({
    kind: 'embed',
    src: `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0`
})

// Turns a YouTube or Vimeo link into an embeddable player, and treats anything
// else (an uploaded mp4, webm or mov) as a video file.
export const getVideoSource = (value: string | null | undefined): VideoSource | null => {
    const url = value?.trim()

    if (!url) return null
    if (url.startsWith('/')) return { kind: 'file', src: url }

    let parsed: URL

    try {
        parsed = new URL(url)
    }
    catch {
        return null
    }

    const host = parsed.hostname.replace(/^(www|m)\./, '')

    if (host === 'youtu.be') {
        const id = parsed.pathname.split('/').filter(Boolean)[0]

        return id ? youtubeEmbed(id) : null
    }

    if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
        const id = parsed.searchParams.get('v') ?? parsed.pathname.match(/^\/(?:embed|shorts|live)\/([^/?#]+)/)?.[1]

        return id ? youtubeEmbed(id) : null
    }

    if (host === 'vimeo.com' || host === 'player.vimeo.com') {
        const id = parsed.pathname.match(/(\d{5,})/)?.[1]

        return id ? { kind: 'embed', src: `https://player.vimeo.com/video/${id}?autoplay=1` } : null
    }

    return { kind: 'file', src: url }
}
